import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ICalendarAuth, ResponseWithStatus } from '@gettactic/api';

export const useOpenWithIntegrationCheck = ({
  enabled = false,
  refetchInterval = 1000,
  apiClient
}: {
  enabled?: boolean;
  refetchInterval?: number;
  apiClient: {
    getMicrosoftPermissions: () => Promise<ResponseWithStatus<ICalendarAuth>>
  }
}) => {
  const { refetch, isRefetching } = useQuery({
    queryKey: ['calendar-auth'],
    queryFn: () => apiClient.getMicrosoftPermissions(),
    enabled, 
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval
  });

  const getShouldRequestDelegatedAccess = useCallback(async () => {
    if(!enabled) {
      return false;
    }

    const freshData = await refetch();
    const freshPermissions = freshData.data?.result;

    if(!freshPermissions) {
      return false;
    }

    return freshPermissions.requires_delegated_access && !freshPermissions.has_delegated_access;
  }, [enabled, refetch]);

  return {
    getShouldRequestDelegatedAccess,
    isRefetching
  }
};
